/**
 * PB Bundle Detail — pb-bundle-detail.js
 * Quản lý: image carousel, variant select, personalization, sidebar steps, ATC
 */

(function () {
  'use strict';

  var totalItems      = window._pbBundleItemCount || 0;
  var bundleState     = {}; /* { productId: { variantId, title, personalization, price } } */
  var currencyRate    = 1; /* Shopify prices are in cents */

  function formatMoney(cents) {
    var amount = cents / 100;
    return amount.toLocaleString('en-US', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD' });
  }

  function updateRunningPrice() {
    var runningEl    = document.getElementById('pb-bundle-running-price');
    var discountLine = document.getElementById('pb-bundle-discount-line');
    var discountedEl = document.getElementById('pb-bundle-discounted-price');
    if (!runningEl) return;

    var running = 0;
    Object.keys(bundleState).forEach(function (id) {
      if (bundleState[id]._added) running += bundleState[id].price || 0;
    });

    runningEl.textContent = formatMoney(running);

    var discountPct = window._pbBundleDiscount || 0;
    if (discountLine && discountedEl && discountPct > 0 && running > 0) {
      var discounted = running * (1 - discountPct / 100);
      discountedEl.textContent = formatMoney(discounted);
      discountLine.style.display = '';
    } else if (discountLine) {
      discountLine.style.display = 'none';
    }
  }

  /* ── Helpers ── */
  function allItemsAdded() {
    var addedCount = 0;
    Object.keys(bundleState).forEach(function (id) {
      if (bundleState[id]._added) addedCount++;
    });
    return addedCount >= totalItems;
  }

  function updateCTA() {
    var btn  = document.getElementById('pb-bundle-atc');
    var hint = document.getElementById('pb-bundle-hint');
    if (!btn) return;
    var done = allItemsAdded();
    btn.disabled = !done;
    if (hint) hint.style.display = done ? 'none' : '';
  }

  function markSidebarStep(productId, done) {
    var step = document.querySelector('.pb-bd-sidebar__step[data-product-id="' + productId + '"]');
    if (!step) return;
    step.classList.toggle('is-done', done);
  }

  function markCardAdded(productId, added) {
    var card = document.querySelector('.pb-bd-card[data-product-id="' + productId + '"]');
    if (!card) return;
    card.classList.toggle('is-added', added);
  }

  /* ── Image carousel ── */
  function initCarousel(card) {
    var imgs  = card.querySelectorAll('.pb-bd-card__img');
    if (imgs.length <= 1) return;

    var current = 0;

    function goTo(index) {
      imgs[current].classList.remove('is-active');
      current = (index + imgs.length) % imgs.length;
      imgs[current].classList.add('is-active');
    }

    var prev = card.querySelector('.pb-bd-card__arrow--prev');
    var next = card.querySelector('.pb-bd-card__arrow--next');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
  }

  /* ── Variant selection ── */
  function initVariants(card) {
    var productId   = card.dataset.productId;
    var productName = card.querySelector('.pb-bd-card__title')
                       ? card.querySelector('.pb-bd-card__title').textContent.trim()
                       : '';
    var btns = card.querySelectorAll('.pb-bd-card__variant-btn');
    var optionValueEl = document.querySelector('[data-option-label="' + productId + '"]');

    function buildLabel(variantTitle) {
      return variantTitle && variantTitle !== 'Default Title'
        ? productName + ' — ' + variantTitle
        : productName;
    }

    /* Auto-select first available */
    var firstBtn = btns[0];
    if (firstBtn) {
      bundleState[productId] = bundleState[productId] || {};
      bundleState[productId].variantId = firstBtn.dataset.variantId;
      bundleState[productId].title     = buildLabel(firstBtn.dataset.variantTitle);
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        bundleState[productId] = bundleState[productId] || {};
        bundleState[productId].variantId = btn.dataset.variantId;
        bundleState[productId].title     = buildLabel(btn.dataset.variantTitle);

        if (optionValueEl) optionValueEl.textContent = btn.dataset.variantTitle;

        if (card.classList.contains('is-added')) {
          markSidebarStep(productId, true);
        }
      });
    });

    /* Single variant — auto-register */
    var singleInput = card.querySelector('.pb-bd-single-variant');
    if (singleInput) {
      bundleState[productId] = {
        variantId: singleInput.dataset.variantId,
        title:     buildLabel(singleInput.dataset.variantTitle)
      };
    }
  }

  /* ── Personalization input ── */
  function initPersonalization(card) {
    var productId = card.dataset.productId;
    var input = card.querySelector('.pb-bd-card__personaliz-input');
    if (!input) return;

    var countEl = card.querySelector('[data-count="' + productId + '"]');

    input.addEventListener('input', function () {
      var val = input.value;
      if (countEl) countEl.textContent = val.length;
      if (val.trim() !== '') input.classList.remove('is-error');
      bundleState[productId] = bundleState[productId] || {};
      bundleState[productId].personalization = val;
    });
  }

  /* ── Add to Bundle button ── */
  function initAddBtn(card) {
    var productId = card.dataset.productId;
    var cardPrice = parseInt(card.dataset.price || '0', 10);
    var btn = card.querySelector('.pb-bd-card__add-btn');
    if (!btn) return;

    /* Store price on state init */
    bundleState[productId] = bundleState[productId] || {};
    bundleState[productId].price = cardPrice;

    btn.addEventListener('click', function () {
      if (!bundleState[productId] || !bundleState[productId].variantId) return;

      /* Require personalization if input exists */
      var personalizInput = card.querySelector('.pb-bd-card__personaliz-input');
      if (personalizInput && personalizInput.value.trim() === '') {
        personalizInput.focus();
        personalizInput.classList.add('is-error');
        return;
      }
      if (personalizInput) personalizInput.classList.remove('is-error');

      var alreadyAdded = card.classList.contains('is-added');

      if (alreadyAdded) {
        card.classList.remove('is-added');
        markSidebarStep(productId, false);
        delete bundleState[productId]._added;
      } else {
        card.classList.add('is-added');
        markSidebarStep(productId, true);
        bundleState[productId]._added = true;
      }

      updateRunningPrice();
      updateCTA();
    });
  }

  /* ── Complete Your Bundle → Add bundle product to cart ── */
  function initCTA() {
    var btn = document.getElementById('pb-bundle-atc');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      var bundleVariantId = window._pbBundleVariantId;
      if (!bundleVariantId) {
        alert('Bundle product not found. Please contact us.');
        return;
      }

      /* Build line_item.properties from each item selection */
      var properties = {};
      var stepNum = 1;
      Object.keys(bundleState).forEach(function (productId) {
        var state = bundleState[productId];
        if (!state.variantId) return;

        var label = 'Item ' + stepNum;
        properties[label] = state.title || state.variantTitle || ('Variant ' + state.variantId);

        if (state.personalization) {
          properties['Personalization ' + stepNum] = state.personalization;
        }

        stepNum++;
      });

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          items: [{
            id:         bundleVariantId,
            quantity:   1,
            properties: properties
          }]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          /* Swap sidebar to success state */
          var sidebar    = document.querySelector('.pb-bd-sidebar');
          var successEl  = document.getElementById('pb-bundle-success');
          if (sidebar && successEl) {
            /* Hide everything except success panel */
            Array.from(sidebar.children).forEach(function (el) {
              if (el.id !== 'pb-bundle-success') el.style.display = 'none';
            });
            successEl.style.display = 'flex';
          }

          /* Open Prestige cart drawer */
          setTimeout(function () {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
            }
          }, 400);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Complete Your Bundle';
          alert('Something went wrong. Please try again.');
        });
    });
  }

  /* ── Init all cards ── */
  function init() {
    var cards = document.querySelectorAll('.pb-bd-card');
    cards.forEach(function (card) {
      initCarousel(card);
      initVariants(card);
      initPersonalization(card);
      initAddBtn(card);
    });

    initCTA();
    updateCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
